import { create } from 'zustand'

// Mobile navigation drawer state — single global toggle that Topbar's
// hamburger button controls and Sidebar consumes. On `lg` (>=1024px) the
// sidebar renders inline and this state is ignored. Below that breakpoint
// the sidebar renders as a slide-over drawer.
//
// Pure UI/UX layer; no backend coupling. Closes automatically on route
// change via Sidebar's nav Link onClick.

interface MobileNavStore {
  sidebarOpen: boolean
  openSidebar: () => void
  closeSidebar: () => void
  toggleSidebar: () => void
}

export const useMobileNavStore = create<MobileNavStore>((set) => ({
  sidebarOpen: false,
  openSidebar: () => set({ sidebarOpen: true }),
  closeSidebar: () => set({ sidebarOpen: false }),
  toggleSidebar: () => set((s) => ({ sidebarOpen: !s.sidebarOpen })),
}))
